import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { GuardTourState, GuardTour } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<GuardTourState, RootState> = {
	/** Guard Tour Setup */
	async fetchGuardTours({ commit }, groupID: number) {
		const { data } = await api.fetchGuardTours(groupID);
		data.forEach((tour, index, arr) => {
			arr[index].guardTourSteps ?? [];
		});
		commit("setGuardTours", data);
	},
	async fetchGuardTour({ commit }, guardTourId: number) {
		const { data } = await api.fetchGuardTour(guardTourId);
		commit("setGuardTour", data);
	},
	async fetchAssessmentTours({ commit }, groupId: number) {
		commit("setAssessmentTours", []);
		const { data } = await api.fetchAssessmentTours(groupId);
		commit("setAssessmentTours", data);
	},
	async addNewGuardTour({ commit }, guardTour: GuardTour) {
		let { data } = await api.addGuardTour(guardTour);
		if (!data.guardTourSteps) data.guardTourSteps = [];
		commit("addGuardTour", data);
		return data;

	},
	async deleteGuardTour({ commit }, guardTourId: number) {
		await api.deleteGuardTour(guardTourId);
		commit("deleteGuardTour", guardTourId);
	},
	async updateGuardTour({ commit }, guardTour: GuardTour) {

		let { data } = await api.updateGuardTour(guardTour);

		commit("setGuardTour", data);
		return data;
	}
};
